import * as R from "ramda";

const border = {
  border: {
    right: {
      style: "thick",
      color: "#000000"
    }
  }
};
const font = {
  font: {
    bold: true
  }
};

const style = {
  ...font,
  fill: {
    type: "pattern",
    patternType: "solid",
    bgColor: "#fbd4b4",
    fgColor: "#fbd4b4"
  }
};
const frozenStyle = {
  ...font,
  fill: {
    type: "pattern",
    patternType: "solid",
    bgColor: "#00b050",
    fgColor: "#00b050"
  }
};
const frozenStyleEnd = {
  ...font,
  ...border,
  fill: {
    type: "pattern",
    patternType: "solid",
    bgColor: "#00b050",
    fgColor: "#00b050"
  }
};
const styleEnd = {
  ...font,
  ...border,
  fill: {
    type: "pattern",
    patternType: "solid",
    bgColor: "#fbd4b4",
    fgColor: "#fbd4b4"
  }
};

type MergeHeaderType = {
  sheet: any;

  mergeHeader: string | null;
  start: number;
  end: number;
};
const mergeExcelHeader = ({
  sheet,

  mergeHeader,
  start,
  end
}: MergeHeaderType) => {
  sheet
    .cell(1, start, 1, end, true)
    .string(R.isNil(mergeHeader) ? "" : mergeHeader)
    .style({
      alignment: {
        horizontal: ["center"]
      },
      ...border
    });
  return sheet;
};

type HeadersType = {
  sheet: any;
  frozen?: boolean;
  headers: string[];
  start: number;
  end: number;
};
const excelHeaders = ({
  sheet,
  frozen = false,
  headers,
  start,
  end
}: HeadersType) => {
  headers.map((val: string, i: number) => {
    const col = R.add(i, start);
    const sty = frozen
      ? R.equals(col, end)
        ? frozenStyleEnd
        : frozenStyle
      : R.equals(col, end)
      ? styleEnd
      : style;
    return sheet
      .cell(2, col)
      .string(val)
      .style(sty);
  });
  return sheet;
};

type ExcelHeaderType = {
  sheet: any;
  frozen?: boolean;
  mergeHeader: string | null;
  headers: string[];
  start: number;
  end: number;
};
const excelHeader = ({
  sheet,
  frozen = false,
  mergeHeader,
  headers,
  start,
  end
}: ExcelHeaderType) => {
  mergeExcelHeader({ sheet, mergeHeader, start, end });
  excelHeaders({ sheet, headers, frozen, start, end });
  return sheet;
};

export const createPVIHeaders = (sheet: any) => {
  sheet.row(1).freeze();
  sheet.row(2).freeze();
  sheet.column(1).freeze();
  sheet.column(2).freeze();
  sheet.column(3).freeze();
  sheet.column(4).freeze();
  sheet.column(1).setWidth(8);
  sheet.column(2).setWidth(15);
  sheet.column(3).setWidth(8);
  sheet.column(4).setWidth(25);

  excelHeader({
    sheet,
    mergeHeader: "",
    headers: ["PVI", "MercatiBidding", "UP", "DatetimeOffset"],
    frozen: true,
    start: 1,
    end: 4
  });

  //MisurePrevisionaliBiddingPVI
  excelHeader({
    sheet,
    mergeHeader: "MisurePrevisionaliBiddingPVI",
    headers: [
      "Provider",
      "Version",
      "Q_GR1",
      "Q_GR2",
      "Q_GR3",
      "Q_GR4",
      "P_GR1",
      "P_GR2",
      "P_GR3",
      "P_GR4"
    ],
    start: 5,
    end: 14
  });
  //MisurePrezziBiddingPVI
  excelHeader({
    sheet,
    mergeHeader: "MisurePrezziBiddingPVI",
    headers: [
      "PVI_RagioneSociale",
      "MercatiBidding",
      "UploadId",
      "Q_GR1",
      "Q_GR2",
      "Q_GR3",
      "Q_GR4",
      "P_GR1",
      "P_GR2",
      "P_GR3",
      "P_GR4"
    ],
    start: 15,
    end: 25
  });
  //DisponibilitaCapacitaMassimaPVI
  excelHeader({
    sheet,
    mergeHeader: "DisponibilitaCapacitaMassimaPVI",
    headers: [
      "PVI_RagioneSociale",
      "UploadId",
      "DisponibilitaPVI",
      "CapacitaMassimaPVI",
      "CapacitaInstallataMW"
    ],
    start: 26,
    end: 30
  });
  //Computed
  excelHeader({
    sheet,
    mergeHeader: "Computed",
    headers: ["Tensione"],
    start: 31,
    end: 31
  });
  //Computed
  excelHeader({
    sheet,
    mergeHeader: "Result",
    headers: [
      "Q_GR1",
      "Q_GR2",
      "Q_GR3",
      "Q_GR4",
      "P_GR1",
      "P_GR2",
      "P_GR3",
      "P_GR4"
    ],
    start: 32,
    end: 39
  });

  return sheet;
};
